module.exports = __webpack_public_path__ + "static/media/shraddha_darade.5aa216d0.png";